import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { ModalController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { ControlMessagesComponent } from '../../components/controlmessagecomponent/controlmessagecomponent';
import { ListComponent } from "../../components/listcomponent/listcomponent";
import { Member } from "../../models/interfaces/member.model";
import { Settings } from "../../models/interfaces/settings.model";
import { PledgeStatus } from "../../models/interfaces/pledgestatus.model";
import { PledgeType } from "../../models/interfaces/pledgetype.model";
import { PledgePage } from "../../pages/pledge/pledge";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-pledge_add",
  templateUrl: "pledge_add.html",
})
export class PledgeAddPage {
  private dataFromOtherPage = null;
  private loading: any;
  private pledgetype$: Observable<PledgeType[]>;
  private pledgeitem$: Observable<Settings[]>;
  private pledgestatus$: Observable<PledgeStatus[]>;
  private pledgeitem_by_name$ = [];
  private defpledgeitem$: Observable<Settings[]>;
  private member$: Observable<Member[]>;
  private memberForm: FormGroup;
  private pledgeForm: FormGroup;
  private pledgeItemForm: FormGroup;
  private member: Member;
  private harelineid: string = null;
  private pl_date: string = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate() + 1).toISOString().substring(0, 10);
  private hl_runno = 0;
  private mb_id: number;
  private mb_hashname: string;
  private hl_id: number;
  private se_id: number;
  private pt_id: number;
  private pt_name: string;
  private ps_id: number;
  private ps_name: string;
  private se_key_value: number;
  private se_key_name: string;
  private pl_remark: string;
  private pl_qty = 1;
  private pi_default_flg;
  private pl_amount: number;
  private smember: string;
  private smemberM: Member[];
  private styleName: string ="";

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public alertCtrl: AlertController,
    public loadingCtrl: LoadingController, public modalCtrl: ModalController,
  ) {
    console.log("PledgeAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");

    this.pledgeForm = this.formBuilder.group({
      "hl_runno": ["", [Validators.required, Validators.min(1), Validators.max(9999)]],
      "mb_hashname": ["", [Validators.required]],
      "pl_amount": "",
      "pl_date": ["", [Validators.required]],
      "pl_qty": ["", [Validators.required, Validators.min(1), Validators.max(100)]],
      "pl_remark": [""],
      "ps_id": ["", [Validators.required]],
      "ps_name": ["", [Validators.required]],
      "pt_id": ["", [Validators.required]],
      "pt_name": ["", [Validators.required]],
      "se_id": ["", [Validators.required]],
      "se_key_name": ["", [Validators.required]],
    });
  }

  private ionViewWillEnter() {
    console.log("PledgeAddPage ionViewWillEnter");
    this.onInitPage();
  }
  private callback = (data) => {
    this.dataFromOtherPage = data;
    console.log("data received from other page", this.dataFromOtherPage);
  }
  private onInitPage() {
    console.log("PledgeAddPage onInitPage");

    if (!(this.navParams.get("hareline") === undefined || this.navParams.get("hareline") === null)) {
      this.harelineid = this.navParams.get("hareline")[0].id;
      this.pl_date = this.navParams.get("hareline")[0].hl_datetime;
      this.hl_runno = this.navParams.get("hareline")[0].hl_runno;
      this.hl_id = this.navParams.data.hareline[0].hl_id;

      this.db.dbCol({
        "action": "select", "mapObject": "pledge_type",
        "sqlExtended": "  order by pledge_type.pt_order"
      }).subscribe((ret) => {
        this.pledgetype$ = ret;
        this.pt_id = ret[0].pt_id;
        this.pt_name = ret[0].pt_name;
        this.pledgeForm.controls.pt_id.setValue(this.pt_id);
        this.pledgeForm.controls.pt_name.setValue(this.pt_name);
      });
    }

    if (!(this.navParams.get("pledge") === undefined || this.navParams.get("pledge") === null)) {
      /*This is the case when the add pledge is called via the upcoming birthdays */
      this.mb_hashname = this.navParams.data.pledge.mb_hashname;

      this.db.dbCol({
        "action": "select", "mapObject": "pledge_type",
        "sqlExtended": " where pt_id=2 "
      }).subscribe((ret) => {
        this.pledgetype$ = ret;
        ret.forEach((element) => {
          this.pt_id = element.pt_id;
          this.pt_name = element.pt_name;
          this.pledgeForm.controls.pt_id.setValue(this.pt_id);
          this.pledgeForm.controls.pt_name.setValue(this.pt_name);
        });
      });
      this.mb_id = this.navParams.data.pledge.mb_id;
    }

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Pledge' order by settings.se_order"
    }).subscribe((ret) => {
      this.pledgeitem$ = ret;
      ret.forEach((element) => {
        this.pledgeitem_by_name$[element.se_id] = {};
        this.pledgeitem_by_name$[element.se_id].se_id = element.se_id;
        this.pledgeitem_by_name$[element.se_id].se_key_name = element.se_key_name;
        this.pledgeitem_by_name$[element.se_id].se_key_value = element.se_key_value;
      });
      ret.forEach((element) => {
        // Set Default values and update form
        if (Number(element.se_attribute1) === Number("1")) {
          this.se_id = element.se_id;
          this.se_key_name = element.se_key_name;
          this.se_key_value = element.se_key_value;
          this.pl_amount = element.se_key_value;
          this.pledgeForm.controls.se_id.setValue(element.se_id);
          this.pledgeForm.controls.se_key_name.setValue(element.se_key_name);
        }
      });
    });



    this.db.dbCol({
      "action": "select", "mapObject": "pledge_status",
      "sqlExtended": " order by pledge_status.ps_order"
    }).subscribe((ret) => {
      this.pledgestatus$ = ret;
      ret.forEach((element) => {
        // Set Default values and update form
        if (Number(element.ps_default_flg) === Number("1")) {
          this.ps_id = element.ps_id;
          this.ps_name = element.ps_name;
          this.pledgeForm.controls.ps_id.setValue(this.ps_id);
          this.pledgeForm.controls.ps_name.setValue(this.ps_name);
        }
      });
    });

    this.pledgeForm.controls.mb_hashname.setValue(this.mb_hashname);
    this.pledgeForm.controls.hl_runno.setValue(this.hl_runno);
    this.pledgeForm.controls.se_id.setValue(this.se_id);
    this.pledgeForm.controls.pt_name.setValue(this.pt_name);
    this.pledgeForm.controls.pl_date.setValue(this.pl_date);
    this.pledgeForm.controls.se_key_name.setValue(this.se_key_name);
    this.pledgeForm.controls.pl_qty.setValue(this.pl_qty);
    this.pledgeForm.controls.pl_amount.setValue(this.pl_amount);
    this.pledgeForm.controls.ps_id.setValue(this.ps_id);
    this.pledgeForm.controls.ps_name.setValue(this.ps_name);

  }

  private openOtherPage() {
    this.navCtrl.push("OtherPage", {
      "callback": this.callback,
    });
  }

  private selectMember(val) {
    console.log("HarelineAddPage selectHareList");
    let selection = this.modalCtrl.create(ListComponent, { "obs": "member", "sel": val, "type": "S" });
    selection.present();
    selection.onDidDismiss((data) => {
      if (data != null) {
        this.mb_id = data[0].mb_id;
        this.smemberM = data;
        this.smember = data.map((v) => v.mb_hashname).toString();
      }
    });
  }

  private goback() {
    console.log("PledgeAddPage goback");
    this.navCtrl.pop();
  }

  private changeSelect_pi_name(_pi_name) {
    console.log("PledgeAddPage changeSelect_pi_name");
    this.se_key_value = this.pledgeitem_by_name$[_pi_name].se_key_value;
    this.se_id = this.pledgeitem_by_name$[_pi_name].se_id;
    this.pl_amount = this.se_key_value * this.pl_qty;
  }
  private onInput_pl_qty(_pl_qty) {
    console.log("PledgeAddPage onInput_pl_qty");
    this.pl_qty = _pl_qty;
    this.pl_amount = this.se_key_value * this.pl_qty;
  }

  private addPledge(value: any) {
    console.log("PledgeAddPage addPledge");

    const formValues: any = {
      "hl_id": this.hl_id,
      "mb_id": this.mb_id,
      "pl_amount": value.pl_amount,
      "pl_date": value.pl_date,
      "pl_qty": value.pl_qty,
      "pl_rate": this.se_key_value,
      "pl_remark": value.pl_remark,
      "ps_id": value.ps_id,
      "pt_id": value.pt_id,
      "se_id": value.se_id,
    };

    this.db.dbCol({ "action": "insert", "mapObject": "pledge", ...formValues })
      .subscribe();
    this.navCtrl.pop();
  }

  private ngOnDestroy() {
    console.log("PledgeAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/pledge/pledge_add.ts